export default __webpack_public_path__ + "static/media/playing.c70e9369.jpg";